var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":_vm.$t('pins.pageTitle'),"description":_vm.$t('pins.pageSubtitle'),"to":{ name: _vm.RouteName.General }}},[_c('PinsForm'),_c('PinsList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }